import {
  KontentMediaImage,
  Image,
  KontentMediaIcon,
  KontentMediaLottie,
  LottieData,
} from "../types";
import { getMultiChoice } from "./multichoice";
import { stripHtml } from "./descriptions";

export function formatImages(mediaImage: KontentMediaImage["elements"]): {
  largeImage: Image;
  smallImage: Image;
} {
  return {
    largeImage: {
      item: mediaImage?.image?.value[0],
      alt:
        mediaImage?.alt_text?.value ||
        stripHtml(mediaImage?.image?.value[0]?.description),
      caption: mediaImage?.caption,
    },
    smallImage: {
      item: mediaImage?.small_image?.value[0],
      alt:
        mediaImage?.alt_text?.value ||
        stripHtml(mediaImage?.small_image?.value[0]?.description),
      caption: mediaImage?.caption,
    },
  };
}

export function formatLottie(
  mediaLottie: KontentMediaLottie["elements"]
): LottieData | null {
  const src = mediaLottie?.lottie_file?.value?.[0]?.url;
  if (!src) return null;
  return {
    src,
    animate: getMultiChoice(mediaLottie.animate),
    speed: mediaLottie.animation_speed?.value ?? 1,
    loop: getMultiChoice(mediaLottie.loop_animation),
  };
}

export function formatIcon(mediaIcon: KontentMediaIcon["elements"]): Image {
  return {
    item: mediaIcon?.icon?.value[0],
    alt: mediaIcon?.alt_text?.value,
  };
}
